export default {
	init: function(utils, Popin) {
		const popinEl = document.querySelector('.js-popin-newsletter')

        if (popinEl) {

            const popinInstance = new Popin(popinEl, {
                openBtnCSSSelector: '.js-popin-newsletter-open',
                closeBtnCSSSelector: '.js-popin-newsletter-close',
                popinBackCSSSelector: '.js-popin-newsletter-back',
                popinContentCSSSelector: '.js-popin-newsletter-content'
            })

		}

		const popinElActualites = document.querySelector('.js-popin-newsletter-actualites')

        if (popinElActualites) {

            const popinActualitesInstance = new Popin(popinElActualites, {
                openBtnCSSSelector: '.js-popin-newsletter-actualites-open',
                closeBtnCSSSelector: '.js-popin-newsletter-actualites-close',
                popinBackCSSSelector: '.js-popin-newsletter-actualites-back',
                popinContentCSSSelector: '.js-popin-newsletter-actualites-content'
            })

		}
	}
}